import { Button, Col, Form, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  SOCIAL_CREATE,
  SOCIAL_DELETE,
  SOCIAL_TYPE,
  SOCIAL_UPDATE,
} from "../../lib/config";
import { FormInputItem } from "../../components/formInput";
import {
  CreateDataOnServer,
  GetDataFromServer,
  UpdateDateOnServer,
} from "../../lib/api";
import toast from "react-hot-toast";
import { FileImageOutlined, LinkOutlined } from "@ant-design/icons";

export default function SocialForm({ edit, closeDrawer }) {
  const { access_token, csrf_token, ui_size } = useSelector((state) => state.user);

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [socialMediaList, setSocialMediaList] = useState([]);

  async function getDataList() {
    await GetDataFromServer(SOCIAL_TYPE, access_token)
      .then(({ data: { data: res, total } }) => {
        setSocialMediaList(res);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList();
  }, []);

  async function submitHandler(values) {
    setLoading(true);

    const apiCall = edit
      ? UpdateDateOnServer(
          SOCIAL_UPDATE,
          edit.id,
          values,
          access_token,
          csrf_token
        )
      : CreateDataOnServer(SOCIAL_CREATE, values, access_token, csrf_token);
    apiCall
      .then(() => {
        toast.success(
          edit
            ? "Updated social successfully"
            : "Created social successfully"
        );
        setLoading(false);
        closeDrawer(true);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  return (
    <Form
      size={ui_size}
      form={form}
      layout="vertical"
      initialValues={edit ? edit : {}}
      onFinish={submitHandler}
    >
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="Social Type"
            name="social_media_type"
            rules={[
              { required: true },
            ]}
          >
            <Select
              placeholder={
                <span>
                  <FileImageOutlined style={{ marginRight: 8 }} />
                  Select Social Media Type
                </span>
              }
              options={socialMediaList.map((value) => ({
                label: value,
                value: value,
              }))}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <FormInputItem
            label="Link"
            name="link_url"
            icon={<LinkOutlined />}
            placeholder="Enter link url"
            rules={[{ required: true, message: "Please link url" }]}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24} align="right">
          <Button type="primary" htmlType="submit" loading={loading}>
            {edit ? "Update" : "Create"}
          </Button>
          <Button
            onClick={() => closeDrawer(false)}
            style={{ marginLeft: "16px" }}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
